import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";

import List from 'views/RebateEarningsReport/List'



class RebateEarningsReport extends React.Component {
  render() {

    return (
          <Switch>
            <Route component={List}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(RebateEarningsReport);



// WEBPACK FOOTER //
// ./src/views/RebateEarningsReport/RebateEarningsReport.jsx